import { render, staticRenderFns } from "./AddNewCongress.vue?vue&type=template&id=6e45bccd"
import script from "./AddNewCongress.vue?vue&type=script&lang=js"
export * from "./AddNewCongress.vue?vue&type=script&lang=js"
import style0 from "./AddNewCongress.vue?vue&type=style&index=0&id=6e45bccd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports